// extracted by mini-css-extract-plugin
export default {"messageAssistResponse":"MessageAssist-module__messageAssistResponse--qyVN0","messageAssistResponseBody":"MessageAssist-module__messageAssistResponseBody--Q04TE"};